import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import copy from 'copy-to-clipboard';
import classNames from 'classnames';
import copyIcon from 'core/assets/svg/copy.svg';
import { useToast } from 'core/components/toast';
import { useStore } from 'core/store';
import useSession from 'core/hooks/use-session';
import { awsDateToStringDate } from 'core/helpers/formatters';
import { HeaderValue } from './header-value';
import { QuoteSource } from './quote-source';
import { ReferredBy } from './referred-by';
import useStyles from './header.styles';

// The offer's pre-bind ID, rep, quote source and referral. The header shows them in a row; the condensed layout
// shows them as a card in the side column, with the date the offer was last rated.
const QuoteFacts = ({ fromCheckout, condensed }) => {
  const classes = useStyles();
  const toast = useToast();
  const { isAgency, isExternalSales, canModifyAffinityAndLeadSource } = useSession();
  const {
    offer: { offer }
  } = useStore();

  const quote = offer?.quote;
  const existingCustomerId = quote?.existingCustomer?.id;
  const rateControlDate = quote?.global?.rateControlDate;

  const copyPreBindId = () => {
    if (copy(offer.webUserId)) {
      toast.notify({ type: 'success', message: 'Pre-bind ID has been copied to your clipboard.' });
    }
  };

  return (
    <div className={condensed ? classes.factsCard : classes.rowBottom}>
      {condensed && (
        <HeaderValue label="Customer" className={classes.column}>
          {[quote.fname, quote.lname].filter(Boolean).join(' ') || 'Not available'}
        </HeaderValue>
      )}
      {offer.webUserId && (
        <HeaderValue label="Pre-bind ID" className={classNames(classes.column, classes.preBindIdColumn)}>
          <button type="button" className={classes.copyButton} onClick={copyPreBindId}>
            {offer.webUserId}
            <img src={copyIcon} alt="Copy pre-bind ID" className={classes.copyIcon} />
          </button>
        </HeaderValue>
      )}
      {quote.rep && (
        <HeaderValue label="Rep" className={classNames(classes.column, classes.repColumn)}>
          {quote.rep}
        </HeaderValue>
      )}
      {condensed && rateControlDate && (
        <HeaderValue label="Rated on" className={classes.column}>
          {awsDateToStringDate(rateControlDate)}
        </HeaderValue>
      )}
      <QuoteSource
        condensed={condensed}
        canEdit={!isAgency && !fromCheckout && canModifyAffinityAndLeadSource}
        className={classNames(classes.column, classes.quoteSourceColumn)}
      />
      {!existingCustomerId && !(isAgency || isExternalSales) && (
        <ReferredBy
          fromCheckout={fromCheckout}
          inviter={quote.inviter}
          className={classNames(classes.column, classes.referredByColumn)}
        />
      )}
    </div>
  );
};

QuoteFacts.propTypes = {
  fromCheckout: PropTypes.bool,
  condensed: PropTypes.bool
};

QuoteFacts.defaultProps = {
  fromCheckout: false,
  condensed: false
};

export default observer(QuoteFacts);
